import type { Technique } from '../types';
import { EROSION_PARAMS } from './params';
import { draw, elementCount, init, isComplete, step, type ErosionState } from './render';

export const erosion: Technique<ErosionState> = {
  id: 'erosion',
  name: 'Erosion / Sandhaufen',
  category: 'automata',
  description: 'Sandkörner lagern sich an den Buchstaben an — oder tragen sie ab.',
  params: EROSION_PARAMS,
  renderer: 'canvas2d',
  isAnimated: false,
  init,
  step,
  isComplete,
  draw,
  elementCount,
};
